<template>
  <div class="ui-pivot-table__sidebar">
    <slot />
    <SidebarBlock
      v-if="!disableCols"
      v-model="modelValue"
      caption="Columns"
      group="group"
      :section="PivotTableGroup.COLS"
    />
    <SidebarBlock
      v-model="modelValue"
      caption="Rows"
      group="group"
      :section="PivotTableGroup.ROWS"
    />
    <SidebarBlock
      v-model="modelValue"
      caption="Values"
      :section="PivotTableGroup.VALUES"
    />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { PivotTableConfig } from '../utils/types'
import { PivotTableGroup } from '../utils/enums'

import SidebarBlock from './SidebarBlock.vue'

const modelValue = defineModel<PivotTableConfig>()

defineOptions({
  name: 'PivotTableSidebar',
})

const disableCols = inject<boolean>('disableCols')
</script>

<style>
.ui-pivot-table__sidebar {
  @apply min-w-[12rem];
  @apply shrink-0;
  @apply border-r border-l border-gray-100 dark:border-gray-850;
  @apply overflow-y-auto;
}
</style>
